import {deserialize} from 'libs/cerialize';

export class CopyRecordsResponseModel {
    constructor(){
        this.CopiedRecords = [];
        this.WarningMessages = [];
        this.ErrorMessages = [];
    }

    @deserialize
    CopiedRecords: Array<number>;

    @deserialize
    WarningMessages: Array<string>;

    @deserialize
    ErrorMessages: Array<string>;
}